<div class="my-4 flex flex-col gap-4">
  <pr-smartpay-configuration [practice]="practice$ | async" />

  <div>
    <h3 class="!m-0 !font-bold">Terminals</h3>
    <pr-practice-smartpay-terminals [practice]="practice$ | async" />
  </div>
</div>
